import { LuInfo } from "react-icons/lu";
import moment from "moment";
const DateToolTip = ({ hoveredData, ishovered, dataType = "datetime" }) => {
  return (
        <div className="tooltip-container">
          <LuInfo className="table__date__icon" size={19} />
          {ishovered && (
            <div className="tooltip-right">
              <span className="tooltip-text">
                {`${
                  dataType === "datetime"
                    ? moment(hoveredData).isSame(
                        moment(hoveredData).startOf("day")
                      )
                      ? moment.utc(hoveredData).format("DD.MM.YYYY")
                      : moment.utc(hoveredData).format("DD.MM.YYYY HH:mm")
                    : moment(hoveredData, "HH:mm:ss.SSS").utc().format("HH:mm")
                } UTC`}
              </span>
            </div>
          )}
        </div>
  );
};

export default DateToolTip;
